<script setup>

import {storeToRefs} from "pinia";
import {userUserNotificationStore} from "@/stores/userNotification.store";

const userNotificationStore = userUserNotificationStore();
userNotificationStore.fetchAll();
const {notifications, name, status} = storeToRefs(userNotificationStore);

const search = async () => {
  userNotificationStore.fetchAll();
}

const updateStatus = (status) => {
  userNotificationStore.status = status;
  if (status === '') {
    userNotificationStore.name = '';
  }
  userNotificationStore.fetchAll();
}

</script>

<template>
  <van-space direction="vertical" fill>
    <van-search v-model="name" @search="search" @cancel="search" placeholder="Search for your notifications"/>
    <van-grid clickable :column-num="3">
      <van-grid-item icon="filter-o" text="All" :dot="status === ''" @click="updateStatus('')"/>
      <van-grid-item icon="todo-list-o" text="Unread" :dot="status === 'Not Started'"
                     @click="updateStatus('Not Started')"/>
      <van-grid-item icon="passed" text="Read" :dot="status === 'Completed'" @click="updateStatus('Completed')"/>
    </van-grid>

    <div v-if="notifications.length === 0">
      <van-empty description="Empty"/>
    </div>
    <div v-if="notifications.length > 0">
      <span v-for="notification in notifications" :key="notification.id">
        <van-cell-group inset>
          <van-cell is-link :to="'/notification/' + notification.id">
            <template #title>
              <span v-if="notification.completed_at_formatted === null">
                <van-tag round size="medium" type="danger">new</van-tag> &nbsp;
              </span>
              <b>{{ notification.title }}</b>
            </template>
          </van-cell>
          <van-cell title="From" :value="notification.created_by_user"/>
          <van-cell title="Created" :value="notification.created_at_formatted"/>
        </van-cell-group>
        <div>&nbsp;</div>
      </span>
    </div>
  </van-space>
</template>
